import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { masterChartPath } from 'constants/masterChartRoutes';

/**
 * The way back from a MasterChart sub-page: a plain button beside the page's own
 * action (Save, Generate code) or, on a list page, under the list. Not a back
 * link above the title, which nothing else in the app has.
 */
const MasterChartBackButton = () => {
  const { t } = useTranslation('masterchart');
  const navigate = useNavigate();
  return <Button onClick={() => navigate(masterChartPath())}>{t('common.back')}</Button>;
};

export default MasterChartBackButton;
